import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactsService } from 'src/app/shared/services/contacts.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {
  contactForm = this.fb.group({
    contactDataForm: this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.email],
      phone: ['', Validators.required]
    }),
    /*DateForm: this.fb.group({
      date: ['', Validators.required],
      personNumber: ['', Validators.required],
      message: ['', Validators.required]
    }),*/
    visit: [''],
    news: [''],
    privacy: ['', Validators.required],
    terms: ['', Validators.required]
  });

  regForm: FormGroup;
  formattedDate: string;

  constructor(public _ui: UtilsService, private fb: FormBuilder) { }

  ngOnInit() {

  }

  updateDate(date: string) {
    this.formattedDate = date;
  }
}
